import { Counter, TextLine, ItemsList } from 'components/common/tableComponents/cellTemplates';
import PersonSidebarLink from 'components/views/worksheetList/cellTemplates/PersonSidebarLink';
import WorksheetMassCheckboxCell from 'components/views/worksheetMassList/cellTemplates/WorksheetMassCheckboxCell';

const WorksheetMassTableTemplates = {
    checkbox:         WorksheetMassCheckboxCell,
    number:           Counter,
    documents:        ItemsList,
    partsInProject:   ItemsList,
    education:        ItemsList,
    text:             PersonSidebarLink,
    prevStageResults: ItemsList,
    working:          ItemsList,
};

export default function getWorksheetMassTableTemplate(columnName) {
    return WorksheetMassTableTemplates[columnName] || TextLine;
}
